import { useCallback } from "react";
import { ApplicationLanguage } from "../../constants";

export const useLanguageDetection = () => {
    const detectLanguage = useCallback(() => {
        const supportedLocaleCodes = Object.values(ApplicationLanguage);
        const supportedLanguageCodes = supportedLocaleCodes.map((lang) => lang.slice(0, 2));

        const browserLanguages = navigator.languages.map((lang) => lang.slice(0, 2));
        const supportedLanguage = browserLanguages.find((lang) => supportedLanguageCodes.includes(lang));

        if (!supportedLanguage) return ApplicationLanguage.EN_EU;

        const supportedLocale = supportedLocaleCodes.find((locale) => locale.startsWith(supportedLanguage));

        return supportedLocale ?? ApplicationLanguage.EN_EU;
    }, []);

    return { detectLanguage };
};
